import * as React from 'react'
import { useCreditsAvailable } from '../swr'

const UseCreditsCheck = () => {
    const { data: availableData } = useCreditsAvailable()

    const simCreditsCheck = React.useCallback(() => {
        if (availableData) {
            if (!!availableData.plan.unlimited) return true
            else {
                if (availableData?.plan?.simulation + availableData?.tokens.simulations > 0) return true
                else return false
            }
        }
    }, [availableData])

    const quizCreditsCheck = React.useCallback(() => {
        if (availableData) {
            if (availableData.plan.unlimited) return true
            else {
                if (availableData?.plan?.quiz + availableData?.tokens.quizzes > 0) return true
                else return false
            }
        }
    }, [availableData])

    const challengeCreditsCheck = React.useCallback(() => {
        if (availableData) {
            if (availableData.plan.unlimited) return true
            else {
                if (availableData?.plan?.challenge + availableData?.tokens.challenges > 0) return true
                else return false
            }
        }
    }, [availableData])

    return { simCreditsCheck, quizCreditsCheck, challengeCreditsCheck }
}

export default UseCreditsCheck
